/* Art & Cafe — theme.js */

/* ---- Mobile Menu ---- */
(function() {
  var toggle = document.querySelector('.aac-header__menu-toggle');
  var menu   = document.getElementById('mobile-menu');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', function() {
    var isOpen = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
    menu.setAttribute('aria-hidden', !isOpen);
  });
})();

/* ---- Cart Count Update (Shopify AJAX) ---- */
(function() {
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart) {
        var el = document.getElementById('cart-count');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function(){});
  }

  document.addEventListener('cart:updated', updateCartCount);
  updateCartCount();
})();

/* ---- Smooth scroll to top ---- */
(function() {
  var backTop = document.querySelector('.aac-footer__back-top');
  if (!backTop) return;
  backTop.addEventListener('click', function(e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
